import React, { useState, useEffect } from 'react';
import TextInput from '../../layout/forms/TextInput';

const ParentObjectKey = ({ state, setState }) => {
    const onChange = (event) => {
        setState({
            ...state,
            parentObjectKey: event.target.value
        })
    }
    return (
        <TextInput
            label="Parent ObjectKey"
            onChange={onChange}
            value={state.parentObjectKey}
        />
    )
}
export default ParentObjectKey